import { ArrowForward } from "@mui/icons-material";
import { Box, Fab, Stack, TextField } from "@mui/material";
import React from "react";

export default function Home() {
  return (
    <Stack
      px={3}
      height={"100vh"}
      justifyContent={"center"}
      alignItems={"center"}
      gap={3}
      component={"form"}
      method="get"
      action="/chat"
      target="_blank"
    >
      <TextField
        required
        size="small"
        fullWidth
        name="authID"
        label="Auth ID"
      />
      <TextField
        required
        size="small"
        fullWidth
        name="userID"
        label="User ID"
      />
      <TextField
        required
        size="small"
        fullWidth
        name="roomID"
        label="Room ID"
      />
      <TextField
        defaultValue={"In verification"}
        required
        size="small"
        fullWidth
        name="chatStatus"
        label="Chat Status"
      />
      <TextField
        defaultValue={"RPayCorp"}
        required
        size="small"
        fullWidth
        name="corporationName"
        label="Corporation Name"
      />
      <TextField
        defaultValue={"VendorOne"}
        required
        size="small"
        fullWidth
        name="vendorName"
        label="Vendor Name"
      />
      <TextField
        defaultValue={"22.5"}
        required
        size="small"
        fullWidth
        name="invoiceAmount"
        label="Invoice Amount"
      />
      <TextField
        defaultValue={"Repay"}
        required
        size="small"
        fullWidth
        name="paymentMethod"
        label="Payment method"
      />
      <Box>
        <Fab type="submit" color="primary" size="small">
          <ArrowForward />
        </Fab>
      </Box>
    </Stack>
  );
}
